
import Celsius from "../../../assets/filled/Celsius.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CelsiusIcon({ className, dataTestid = "CelsiusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Celsius data-testid={dataTestid} className={classes} {...rest} />
  );
}
